import React, { createContext, useContext, useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { api } from './api.js'

const Ctx = createContext(null)

const EMPTY = { edition: '', features: {}, brand: {}, limits: {} }

export function ConfigProvider({ children }) {
  const [cfg, setCfg] = useState(EMPTY)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    (async () => {
      try { setCfg(await api.publicConfig()) } catch { setCfg(EMPTY) } finally { setLoading(false) }
    })()
  }, [])

  return <Ctx.Provider value={{ ...cfg, loading }}>{children}</Ctx.Provider>
}

export const useConfig = () => useContext(Ctx)

// Ukrywa trasę zamiast pokazywać błąd, gdy flaga funkcji jest wyłączona na tej instancji
// (konwencja "ukryj zamiast błędu" — patrz plan Faza 8.4) — analogiczne do RequireAuth/RequireAdmin.
export function RequireFeature({ flag, children }) {
  const { features, loading } = useConfig()
  if (loading) return <div className="splash">Ładowanie…</div>
  if (!features[flag]) return <Navigate to="/" replace />
  return children
}
